import { render, staticRenderFns } from "./addInfoJabatan.vue?vue&type=template&id=a290ffdc&scoped=true"
import script from "./addInfoJabatan.vue?vue&type=script&lang=js"
export * from "./addInfoJabatan.vue?vue&type=script&lang=js"
import style0 from "./addInfoJabatan.vue?vue&type=style&index=0&id=a290ffdc&prod&lang=css"
import style1 from "./addInfoJabatan.vue?vue&type=style&index=1&id=a290ffdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a290ffdc",
  null
  
)

export default component.exports